import { useMemo } from "react";
import { useResource } from "@rest-hooks/core";
import { loadIntlMessages } from "../endpoints/loadIntlMessages";
export function localeLang(locale) {
    const [lang] = locale.split("-");
    return lang;
}
export function useLanguageSettings(tenant, loader, currentLocale, defaultLocale) {
    const locale = useMemo(() => {
        if (tenant.locales.includes(currentLocale))
            return currentLocale;
        const userLanguages = window.navigator.languages ??
            [
                window.navigator.language,
                window.navigator.userLanguage,
                window.navigator.systemLanguage,
                window.navigator.browserLanguage // IE11
            ].filter(Boolean);
        for (const userLocale of userLanguages) {
            const exactMatch = tenant.locales.find(tenantLocale => tenantLocale.toLowerCase() === userLocale.toLowerCase());
            if (exactMatch)
                return exactMatch;
            let languageMatch = tenant.locales.find(tenantLocale => localeLang(tenantLocale) === localeLang(userLocale));
            if (languageMatch)
                return languageMatch;
        }
        if (defaultLocale && tenant.locales.includes(defaultLocale))
            return defaultLocale;
        // Fallback: first locale in tenant-defined list of supported locales
        return tenant.locales[0];
    }, [currentLocale, defaultLocale, tenant.locales]);
    const formats = tenant.getFormats(locale);
    const language = locale.split("-")[0];
    const { tenantName } = tenant;
    const [defaultMessages, tenantMessages] = useResource([loadIntlMessages, { language, loader }], [loadIntlMessages, { language, tenantName, tenant, loader }]);
    const messages = useMemo(() => {
        if (!tenantMessages || !tenantMessages)
            return defaultMessages;
        let messagesWithOverride = { ...defaultMessages };
        for (const [id, message] of Object.entries(tenantMessages)) {
            if (message) {
                messagesWithOverride[id] = message;
            }
        }
        return messagesWithOverride;
    }, [defaultMessages, tenantMessages]);
    return {
        locale,
        messages,
        formats
    };
}
//# sourceMappingURL=useLanguageSettings.js.map